export const APP_ID = 'ng-wall';

export interface IMainboardState {
    posts: IPost[];
}

export interface IConfig {
    background?: string;
    auto?: boolean;
    hashtag?: string;
}

export interface IPost {
    id: string;
    platform: SocialPlatform;
    user?: IUser;
    time?: Date;
    text?: string;
    image: string;
    activated?: boolean;
    index?: number;
}

export interface IUser {
    avatar: string;
    username: string;
}

export enum SocialPlatform {
    INSTAGRAM = 'instagram',
    TWITTER = 'twitter',
    FACEBOOK = 'facebook',
    CUSTOM = 'custom',
}

export function shuffle<T>(a: T[]): T[] {
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
}

const params: URLSearchParams = new URLSearchParams(typeof location !== 'undefined' ? location.search : '');

export function getQueryParam(name: string): string {
    return params.get(name)!;
}

export function delay(ms: number): Promise<void> {
    return new Promise<void>(resolve => setTimeout(resolve, ms));
}
